import { useCallback, useEffect } from 'react'

interface IUseHandleEscKeyPress {
  cb: () => void
  conditionForAddListener: boolean
}

export const useHandleEscKeyPress = ({ cb, conditionForAddListener }: IUseHandleEscKeyPress) => {
  /** -------------------- Methods ----------------------- */
  const handleEscKeyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        cb()
      }
    },
    [cb]
  )

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    if (conditionForAddListener) {
      document.addEventListener('keyup', handleEscKeyPress)
    }

    return () => {
      document.removeEventListener('keyup', handleEscKeyPress)
    }
  }, [conditionForAddListener, cb, handleEscKeyPress])

  return {}
}
